import { ISponsor } from './../../interfaces/index';
import { IUserProfile, IAccountProfile } from '@/interfaces';
import { IRoleAdmin } from '@/interfaces';
import { ILanguage } from '@/interfaces';
import { ISystemFeature } from '@/interfaces';
import { IAction } from '@/interfaces';
import { ICurrency } from '@/interfaces';
import { ICountry } from '@/interfaces';
import { IState } from '@/interfaces';
import { ICity } from '@/interfaces';
import { IAccount } from '@/interfaces';
import { AdminState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
    setUsers(state: AdminState, payload: IUserProfile[]) {
        state.users = payload;
    },
    setUser(state: AdminState, payload: IUserProfile) {
        const users = state.users.filter((user: IUserProfile) => user.id !== payload.id);
        users.push(payload);
        state.users = users;
    },
    setRoles(state: AdminState, payload: IRoleAdmin[]) {
        state.roles = payload;
    },
    setRole(state: AdminState, payload: IRoleAdmin) {
        const roles = state.roles.filter((role: IRoleAdmin) => role.id !== payload.id);
        roles.push(payload);
        state.roles = roles;
    },
    setLanguages(state: AdminState, payload: ILanguage[]) {
        state.languages = payload;
    },
    setLanguage(state: AdminState, payload: ILanguage) {
        const languages = state.languages.filter((language: ILanguage) => language.id !== payload.id);
        languages.push(payload);
        state.languages = languages;
    },
    setSystemFeatures(state: AdminState, payload: ISystemFeature[]) {
        state.systemFeatures = payload;
    },
    setSystemFeature(state: AdminState, payload: ISystemFeature) {
        const systemFeatures = state.systemFeatures
            .filter((systemFeature: ISystemFeature) => systemFeature.id !== payload.id);
        systemFeatures.push(payload);
        state.systemFeatures = systemFeatures;
    },
    setActions(state: AdminState, payload: IAction[]) {
        state.actions = payload;
    },
    setAction(state: AdminState, payload: IAction) {
        const actions = state.actions
            .filter((action: IAction) => action.id !== payload.id);
        actions.push(payload);
        state.actions = actions;
    },
    setCurrencies(state: AdminState, payload: ICurrency[]) {
        state.currencies = payload;
    },
    setCurrency(state: AdminState, payload: ICurrency) {
        const currencies = state.currencies.filter((currency: ICurrency) => currency.id !== payload.id);
        currencies.push(payload);
        state.currencies = currencies;
    },
    // COUNTRIES
    setCountries(state: AdminState, payload: ICountry[]) {
        state.countries = payload;
    },
    setStates(state: AdminState, payload: IState[]) {
        state.states = payload;
    },
    setCities(state: AdminState, payload: ICity[]) {
        state.cities = payload;
    },
    // Account Profiles
    setAccountProfiles(state: AdminState, payload: IAccountProfile[]) {
        state.accountProfiles = payload;
    },
    setAccountProfile(state: AdminState, payload: IAccountProfile) {
        const accounProfiles = state.accountProfiles.filter((profile: IAccountProfile) => profile.id !== payload.id);
        accounProfiles.push(payload);
        state.accountProfiles = accounProfiles;
    },
    // Accounts
    setAccounts(state: AdminState, payload: IAccount[]) {
        state.accounts = payload;
    },
    setAccount(state: AdminState, payload: IAccount) {
        const accounts = state.accounts.filter((account: IAccount) => account.id !== payload.id);
        accounts.push(payload)
        state.accounts = accounts
    },
    removeAccount(state: AdminState, id: number) {
        const accounts = state.accounts.filter((account: IAccount) => account.id !== id)
        state.accounts = accounts;
    },
    //Sponsor mutations
    setSponsors(state: AdminState, payload: ISponsor[]){
        state.sponsors = payload;
    },
    setSponsor(state: AdminState, payload: ISponsor){
        const sponsors = state.sponsors.filter((sponsor: ISponsor) => sponsor.id !== payload.id)
        sponsors.push(payload)
    },
    removeSponsor(state: AdminState, id: number) {
        const sponsors = state.sponsors.filter((sponsor: ISponsor) => sponsor.id !== id)
        state.sponsors = sponsors;
    }
};

const { commit } = getStoreAccessors<AdminState, State>('');

export const commitSetUser = commit(mutations.setUser);
export const commitSetUsers = commit(mutations.setUsers);

export const commitSetRoles = commit(mutations.setRoles);
export const commitSetRole = commit(mutations.setRole);

export const commitSetLanguage = commit(mutations.setLanguage);
export const commitSetLanguages = commit(mutations.setLanguages);

export const commitSetSystemFeature = commit(mutations.setSystemFeature);
export const commitSetSystemFeatures = commit(mutations.setSystemFeatures);

export const commitSetAction = commit(mutations.setAction);
export const commitSetActions = commit(mutations.setActions);

export const commitSetCurrency = commit(mutations.setCurrency);
export const commitSetCurrencies = commit(mutations.setCurrencies);

export const commitSetCountries = commit(mutations.setCountries);
export const commitSetStates = commit(mutations.setStates);
export const commitSetCities = commit(mutations.setCities);

export const commitSetAccountProfiles = commit(mutations.setAccountProfiles);
export const commitSetAccountProfile = commit(mutations.setAccountProfile);

export const commitSetAccounts = commit(mutations.setAccounts);
export const commitSetAccount = commit(mutations.setAccount);
export const commitRemoveAccount = commit(mutations.removeAccount);

//export sponsor mutations
export const commitSetSponsors = commit(mutations.setSponsors);
export const commitSetSponsor = commit(mutations.setSponsor);
export const commitRemoveSponsor = commit(mutations.removeSponsor);

